module.exports = __webpack_public_path__ + "img/join_4_4.27d8f05b.jpg";